import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';

const LeftPlusButton = ({ onClick, icon, label, sx, disabled, iconGap, isMobileOrTablet }) => {
    const defaultSx = {
        position: 'relative',
        width: isMobileOrTablet ? 140 : 200, 
        height: isMobileOrTablet ? 36 : 50, 
        backgroundColor: '#FF669B',
        color: '#FFFFFF',
        borderRadius: '36px',
        padding: isMobileOrTablet ? `0 8px 0 36px` : `0 16px 0 ${iconGap}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: isMobileOrTablet ? '16px' : '16px', // ← Responsive font
        lineHeight: '16px',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#FF669B',
        },
        ...(disabled && {
            backgroundColor: '#F0EFF1',
            color: '#979797',
            cursor: 'not-allowed',
            pointerEvents: 'none',
        }),
        ...sx,
    };

    return (
        <Button onClick={onClick} sx={defaultSx} disabled={disabled}>
            <Box
                component="img"
                src={icon}
                alt="icon"
                sx={{
                    position: 'absolute',
                    left: isMobileOrTablet ? 4 : 7, 
                    width: isMobileOrTablet ? 28 : 36,
                    height: isMobileOrTablet ? 28 : 36,
                }}
            />
            <Typography
                variant="inherit"
                sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: isMobileOrTablet ? '16px' : '20px',
                    lineHeight: isMobileOrTablet ? '16px' : '20px',
                    letterSpacing: 0,
                }}
            >
                {label}
            </Typography>
        </Button>
    );
};

LeftPlusButton.propTypes = {
    onClick: PropTypes.func,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    sx: PropTypes.object,
    disabled: PropTypes.bool,
    iconGap: PropTypes.number,
    isMobileOrTablet: PropTypes.bool,
};

LeftPlusButton.defaultProps = {
    onClick: () => {},
    sx: {},
    disabled: false,
    iconGap: 16,
    isMobileOrTablet: false,
};

export default LeftPlusButton;